import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Dropdown, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  editReverseItem,
  uploadValidate,
} from "./journeySlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  defaultDate,
  formatterStatus,
  getValueStatus,
  paramsMasterAll,
  paramsStatusJourney,
  paramsYesNoType,
  setOptionsMaster,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  statusFormatter,
} from "../../utility";
import { JourneyTable } from "./JourneyTable";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale"; // Import English locale for date-fns
import { InputDateRange } from "../../utility/InputDateRange";
import Select from "react-select";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { selectUser } from "../../modules/Auth";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import BootstrapTable from "react-bootstrap-table-next";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";

export const JourneyPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);
  const user = useSelector(selectUser);
  const dataBranch = useSelector(selectBranch);
  const ref = useRef();

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [startJourney, setStartJourney] = useState("");
  const [endJourney, setEndJourney] = useState("");
  const [status, setStatus] = useState("");
  const [synch, setSynch] = useState("");
  const [optionsSales, setOptionSales] = useState([]);

  const [branch, setBranch] = useState("");
  const [optionsBranch, setOptionBranch] = useState([]);
  const handleChangeBranch = createChangeHandler(setBranch);

  const paramsFilter = {
    company_sales_code: code,
    start_journey_date: startJourney,
    end_journey_date: endJourney,
    status: status,
    branch_code: branch,
    is_pulled: synch,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      setStartJourney(defaultDate);
      setEndJourney(defaultDate);

      const params = {
        ...paramsFilter,
        start_journey_date: defaultDate,
        end_journey_date: defaultDate,
        pageNo: 1,
        pageSize: 10,
      };

      await dispatch(fetchData(params));
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        }),
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(dataUser, setOptionSales, "username", "name_username");
    }
  }, [dataUser]);
  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionBranch,
        "branch_code",
        "branch_name",
      );
    }
  }, [dataBranch]);

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data },
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        }),
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeStatus = createChangeHandler(setStatus);
  const handleChangeSynch = createChangeHandler(setSynch);

  // reverse journey
  const [journeyDate, setJourneyDate] = useState("");
  const [show, setShow] = useState(false);
  const [sales, setSales] = useState("");

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const handleGenerate = async () => {
    const params = {
      journey_date: journeyDate,
      username: sales,
    };

    try {
      const response = await dispatch(editReverseItem(params));
      if (response.payload.data.status_code === 200) {
        await showSuccessDialog(response.payload.message);
        await handleClose();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeSales = createChangeHandler(setSales);
  const handleChangCode = createChangeHandler(setCode);

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  // const handleUpload = async () => {
  //   // const params = tableUpload.filter(
  //   //   (entry) => entry.status_validation === "Success",
  //   // );

  //   // if (params.length === 0) {
  //   //   return showDialog("Please upload data first");
  //   // }

  //   try {
  //     const response = await dispatch(uploadValidate(params));
  //     console.log(response, "response");
  //     if (response.payload.status === 200) {
  //       await showSuccessDialog(response.payload.message);
  //     } else {
  //       showErrorDialog(response.payload.message);
  //     }
  //   } catch (error) {
  //     showErrorDialog(error.message);
  //     console.log(error.message);
  //   }
  // };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
  };

  const handleUpload = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(fileUpload));
        console.log(response, "response");
        if (response.payload.status === 200) {
          await handleCloseUpload();
          await showSuccessDialog(response.payload.data.message);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "uom",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "is active",
      dataField: "is_active",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: statusFormatter,
    },

    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Journey">
          <CardHeaderToolbar>
            {user?.roles[0] === "Super Admin" && (
              <Button className="btn btn-danger mr-3" onClick={() => handleShow()}>
                Reverse
              </Button>
            )}
            <Button
              className="btn btn-danger"
              onClick={() => handleShowUpload()}
            >
              Upload Manual
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filter */}
          <Form className="mb-5">
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsSales}
                      value={getValueStatus(code, optionsSales)}
                      placeholder="Select ..."
                      onChange={handleChangCode}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Journey Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <InputDateRange
                      setEndDate={setEndJourney}
                      setStartDate={setStartJourney}
                      endDate={endJourney}
                      startDate={startJourney}
                      CallApi={fetchData}
                      paramsFilter={paramsFilter}
                      paramsStart={"start_journey_date"}
                      paramsEnd={"end_journey_date"}
                      hidden={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sync</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsYesNoType}
                      value={getValueStatus(synch, paramsYesNoType)}
                      placeholder="Select ..."
                      onChange={handleChangeSynch}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
              </Col>

              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsStatusJourney}
                      value={getValueStatus(status, paramsStatusJourney)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Branch</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsBranch}
                      value={getValueStatus(branch, optionsBranch)}
                      placeholder="Select ..."
                      onChange={handleChangeBranch}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Col sm={3}>
                    <Button
                      className="btn btn-outline-danger"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Col>
                  {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {/* Table */}

          <JourneyTable
            data={Array.isArray(data) ? data : []}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        </CardBody>
      </Card>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reverse</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Journey Date </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="date"
                      value={journeyDate}
                      onChange={(e) => setJourneyDate(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsSales}
                      value={getValueStatus(sales, optionsSales)}
                      placeholder="Select ..."
                      onChange={handleChangeSales}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="mr-4"
            onClick={() => handleClose()}
          >
            Close
          </Button>
          <Button variant="danger" onClick={() => handleGenerate()}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".aes"
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columns}
              hover
              striped
              noDataIndication="Data Not Found"
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
